import { MonoAvatarModule } from '../../../shared/directives/mono-avatar/mono-avatar.module';
import { PatientListComponent } from './../list/patient-list.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MatMenuModule, MatButtonModule } from '@angular/material';

@NgModule({
  declarations: [PatientListComponent],
  imports: [
    CommonModule,
    IonicModule,
    MonoAvatarModule,
    TranslateModule,
    MatMenuModule,
    MatButtonModule
  ],
  exports: [
    PatientListComponent
  ]
})
export class PatientListModule { }
